import { render, staticRenderFns } from "./Cishidai.vue?vue&type=template&id=6a8db8ac&scoped=true&"
import script from "./Cishidai.vue?vue&type=script&lang=js&"
export * from "./Cishidai.vue?vue&type=script&lang=js&"
import style0 from "./Cishidai.vue?vue&type=style&index=0&id=6a8db8ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8db8ac",
  null
  
)

export default component.exports